import Translation from '../../lang/Translation';
import residentIDCard from '../ImportTax/ResidentIDForm/resident-id-card.svg';
import HelperDetailList from '../ui/HelperDetailList/HelperDetailList';
import HelperDetailListItem from '../ui/HelperDetailList/HelperDetailListItem';

function BrazilianResidentIDHelper() {
  return (
    <HelperDetailList>
      <HelperDetailListItem
        icon={residentIDCard}
        info={Translation.getText('checkout.address.field.label.cpfBrazil.helpContent')}
      />
    </HelperDetailList>
  );
}

export default BrazilianResidentIDHelper;
